/**
 * fSpy
 * Copyright (c) 2020 - Per Gantelius
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { CalibrationMode, GlobalSettings, Overlay3DGuide } from '../types/global-settings'

export const defaultGlobalSettings: GlobalSettings = {
  calibrationMode: CalibrationMode.TwoVanishingPoints,
  imageOpacity: 0.2,
  overlay3DGuide: Overlay3DGuide.None
}
